import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../../services/api';
import types from '../../types';
import notification from '../../../services/notification';

function* getAccount() {
  try {
    const { data, status } = yield call(api.setting.getAccount);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_ACCOUNT_SUCCESS, payload: data?.data });
  } catch (error) {
    yield put({ type: types.GET_ACCOUNT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* putAccount({ payload }) {
  try {
    const { status } = yield call(api.setting.putAccount, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.PUT_ACCOUNT_SUCCESS });
    yield put({ type: types.GET_ACCOUNT_START });
  } catch (error) {
    yield put({ type: types.PUT_ACCOUNT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

export function* account() {
  yield all([
    takeLatest(types.GET_ACCOUNT_START, getAccount),
    takeLatest(types.PUT_ACCOUNT_START, putAccount),
  ]);
}
